import { CarrierSubmissionActivityLog } from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/components/CarrierSubmissionActivity';
import { SubmissionActivityLog } from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/components/SubmissionActivity';
import { SubmissionMarketActivityLog } from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/components/SubmissionMarketActivity/SubmissionMarketActivityLog';

export enum ActivityLogLevel {
  Submission,
  SubmissionMarket,
  CarrierSubmission,
}

export interface ActivityLogProps {
  activityLogLevel?: ActivityLogLevel;
}

export const ActivityLogBase = ({ activityLogLevel = ActivityLogLevel.Submission }: ActivityLogProps) => {
  if (activityLogLevel === ActivityLogLevel.SubmissionMarket) {
    return <SubmissionMarketActivityLog />;
  }
  if (activityLogLevel === ActivityLogLevel.CarrierSubmission) {
    return <CarrierSubmissionActivityLog />;
  }
  return <SubmissionActivityLog />;
};
